import React from 'react'
import styles from './Styles.jsx'
import {
  Button,
  Container,
  // Divider,
  // Grid,
  // Header,
  // Icon,
  // Image,
  // List,
  Menu,
  // Segment,
  // Visibility,
} from 'semantic-ui-react'



const MenuItems = () => (
  <Container>
                <Menu.Item position='left' style={styles.menuItem}>
                  <Button as='a' inverted style={styles.menuItem}>Rown Arts</Button>
                </Menu.Item>
    <Menu.Item position='right' style={styles.menuItem} as='a' href='#home'>Home</Menu.Item>
    <Menu.Item style={styles.menuItem} as='a' href='#partners'>Partners</Menu.Item>
    {/* <Menu.Item style={styles.menuItem} as='a'>Protfolio</Menu.Item> */}
    {/* <Menu.Item style={styles.menuItem} as='a' href='#team'>Team</Menu.Item> */}
    <Menu.Item style={styles.menuItem} as='a' href='#contacts'>Contacts</Menu.Item>
  </Container>
)

export default MenuItems



// WEBPACK FOOTER //
// ./src/components/MenuItems.jsx